import React, {useState} from "react";
import HardwareSignInput from "./HardwareSignComponent";
import {
    TextInput,
    FileInput,
    FileField,
    SelectInput,
    RadioButtonGroupInput,
    FormDataConsumer
} from 'react-admin';
import {makeStyles} from "@material-ui/core/styles";
import Styles from "../legal_entity/Styles";
import { useFormState } from 'react-final-form';
import {Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";
import ButtonMui from "@material-ui/core/Button";

const SignComponent = props => {
    const useStyles = makeStyles((theme) => (Styles));
    const classes = useStyles();
    const { values } = useFormState();
    const [warningOpen, setWarningOpen] = useState(false);

    const handleOpen = () => {
        setWarningOpen(true);
    };

    const handleClose = () => {
        setWarningOpen(false);
    };

    return (
        <div className={classes.root}>
            <SelectInput
                formClassName="tab-content-item"
                source="tab"
                label="Тип ЕЦП"
                fullWidth={true}
                initialValue={0}
                choices={process.env.REACT_APP_DEMO_MODE === 'off' ? [
                    {id: 0, name: 'Файловий ключ'},
                    {id: 1, name: 'Апаратний ключ'},
                    {id: 2, name: 'Гряда-301'}
                ] : [
                    {id: 0, name: 'Файловий ключ'},
                    {id: 1, name: 'Апаратний ключ'}
                ]}
                onChange={(event) => {
                    if (event.target?.value === 1) {
                        handleOpen();
                    }
                }}
            />

            <FormDataConsumer formClassName="tab-content-item">
                {({ formData, ...rest }) => ( typeof formData.tab === 'undefined' || formData.tab === 0 ?
                    <div>
                        <FileInput className="digital-signature" formClassName="tab-content-item" source={'sign'} label={"ЕЦП *"} placeholder={"Вкажіть файл електронного цифрового підпису"} >
                            <FileField source="src" title="title" />
                        </FileInput>
                        <TextInput type={"password"} className="digital-signature-password tab-content-item" source={"password"} label={"Пароль ЕЦП *"} />
                    </div>
                    : null)}
            </FormDataConsumer>
            <FormDataConsumer formClassName="tab-content-item">
                {({ formData, ...rest }) => ( formData.tab === 1 ?
                    <HardwareSignInput {...props} />
                : null)}
            </FormDataConsumer>
            <FormDataConsumer formClassName="tab-content-item">
                {({ formData, ...rest }) => ( formData.tab === 2 ?
                    <div>
                        <RadioButtonGroupInput defaultValue={"credentials"} label="Метод доступу КЕП" className="tab-content-item" source="gryadaMethod" fullWidth="true" choices={[
                            { id: 'credentials', name: 'За логіном та паролем' },
                            { id: 'account', name: 'За даними облікового запису' }
                        ]} />
                        <FormDataConsumer formClassName="tab-content-item">
                            {({ formData, ...rest }) => ( formData.gryadaMethod === 'credentials' ?
                                <div>
                                    <TextInput className="tab-content-item" source={"gryadaLogin"} label={"Логін *"} />
                                    <TextInput type={"password"} className="digital-signature-password tab-content-item" source={"gryadaPassword"} label={"Пароль *"} />
                                </div>
                                : null)}
                        </FormDataConsumer>
                    </div>
                    : null)}
            </FormDataConsumer>

            <Dialog
                open={warningOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText>
                        <span>
                            Для роботи із захищеним носієм необхідно запустити&nbsp;
                            <a href="https://cipher.kiev.ua/files/pcs/jnlp/pcs-dev-preview.jnlp">"Агент ЄСКО"</a>,&nbsp;
                            настанова користувача <a href="https://docs.cipher.kiev.ua/x/oIPxAQ" target="_blank" rel="noopener noreferrer"> за посилання</a>.&nbsp;
                            "Агент ЄСКО" потребує встановлення середовища <a href="https://java.com/ru/download/manual.jsp" target="_blank" rel="noopener noreferrer">Java 8</a>.
                        </span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ButtonMui onClick={handleClose} color="primary">
                        OK
                    </ButtonMui>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default SignComponent;
